import { Card, Text, Title, Table, TableHead, TableHeaderCell, TableBody, TableRow, TableCell } from '@tremor/react';
import { Link } from 'react-router-dom';
import { formatInt, formatMxn } from '../lib/format';
import { t } from '../lib/i18n';
import type { TopPart } from '../api/types';

interface Props { rows: TopPart[]; }

export default function TopPartsTable({ rows }: Props) {
  return (
    <Card>
      <Title>{t.tables.topPartsTitle}</Title>
      {rows.length === 0 ? (
        <Text className="mt-4">{t.tables.empty}</Text>
      ) : (
        <Table className="mt-4">
          <TableHead>
            <TableRow>
              <TableHeaderCell className="w-8 text-right">#</TableHeaderCell>
              <TableHeaderCell>{t.tables.cols.part}</TableHeaderCell>
              <TableHeaderCell>{t.tables.cols.description}</TableHeaderCell>
              <TableHeaderCell className="text-right">{t.tables.cols.qty}</TableHeaderCell>
              <TableHeaderCell className="text-right">{t.tables.cols.revenue}</TableHeaderCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((r, i) => (
              <TableRow key={`${r.line}-${r.part}`}>
                <TableCell className="text-right text-tremor-content text-xs tabular-nums">{i + 1}</TableCell>
                <TableCell className="font-mono text-xs">
                  <Link to={`/parts/${encodeURIComponent(r.line)}/${encodeURIComponent(r.part)}`} className="text-tremor-brand hover:underline">
                    {r.line} {r.part}
                  </Link>
                </TableCell>
                <TableCell>{r.pdesc}</TableCell>
                <TableCell className="text-right tabular-nums">{formatInt(r.qty_sold)}</TableCell>
                <TableCell className="text-right tabular-nums">{formatMxn(r.revenue_mxn)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Card>
  );
}
